import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { TextAa } from "@phosphor-icons/react";

export const AudioTranscription = ({ message }) => {
  const [text, setText] = useState(message.transcription || "");
  const [loading, setLoading] = useState(false);

  const run = async () => {
    setLoading(true);
    try {
      const { data } = await api.post(`/transcription/messages/${message.id}`);
      setText(data.transcription || "");
      if (!data.transcription) toast.info("Áudio sem fala reconhecível");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const shown = text || message.transcription;
  if (shown) {
    return (
      <div className="mt-1 px-2 py-1.5 bg-black/5 text-xs italic leading-snug max-w-[280px]" data-testid={`audio-transcription-${message.id}`}>
        <span className="not-italic font-semibold text-[10px] uppercase tracking-wider text-[#0F4C3A] block mb-0.5">Transcrição</span>
        {shown}
      </div>
    );
  }
  if (message.direction !== "in") return null;
  return (
    <button
      onClick={run}
      disabled={loading}
      data-testid={`audio-transcribe-btn-${message.id}`}
      className="mt-1 flex items-center gap-1 text-[11px] font-semibold text-[#0F4C3A] hover:underline disabled:opacity-50"
    >
      <TextAa size={14} weight="bold" />
      {loading ? "Transcrevendo…" : "Transcrever áudio"}
    </button>
  );
};
